// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_AuthUrlResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /instagram/accounts/auth_url
 *
 * Returns the Instagram OAuth login URL plus the random `state` token and
 * the resolved `redirect_uri` so the frontend can complete the OAuth round-trip.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface InstagramAccounts_AuthUrlResponseDados {
auth_url: string
state: string
redirect_uri: string
}

export type InstagramAccounts_AuthUrlResponse = ApiResponse<InstagramAccounts_AuthUrlResponseDados>;

registerResponseContract('InstagramAccounts_AuthUrlResponse', {
  auth_url:     { type: 'string',  required: true },
  state:        { type: 'string',  required: true },
  redirect_uri: { type: 'string',  required: true },
})
